var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    attrs: {
      "width": "1000",
      "title": `${_vm.openRecipe ? '编辑' : '新增'}配方`
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    staticClass: "info-panel",
    attrs: {
      "model": _vm.formItem,
      "rules": _vm.ruleValidate,
      "label-position": "top"
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "销售项目"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.openedSales && _vm.openedSales.name))])]), _c('FormItem', {
    attrs: {
      "label": "客户"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.openedSales.customer && _vm.openedSales.customer.name) + " ")])]), _c('FormItem', {
    attrs: {
      "label": "产品"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.openedSales.material && _vm.openedSales.material.name) + " ")])]), _c('FormItem', {
    attrs: {
      "label": "设为生产配方",
      "prop": "usedInProd"
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    model: {
      value: _vm.formItem.usedInProd,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "usedInProd", $$v);
      },
      expression: "formItem.usedInProd"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入备注...",
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 5
      }
    },
    model: {
      value: _vm.formItem.remark,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "remark", $$v);
      },
      expression: "formItem.remark"
    }
  })], 1), _c('FormItem', [_c('Button', {
    staticStyle: {
      "width": "170px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("保存")]), _c('Button', {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function ($event) {
        _vm.drawerOpened = false;
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _c('div', {
    staticClass: "recipe-panel"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.displayData,
      "border": "",
      "show-summary": "",
      "summary-method": _vm.handleSummary
    },
    scopedSlots: _vm._u([{
      key: "ratio",
      fn: function (_ref) {
        var row = _ref.row,
          index = _ref.index;
        return [row.name !== '水' ? _c('div', [_c('InputNumber', {
          staticClass: "input-ratio",
          attrs: {
            "max": 100,
            "min": 0,
            "step": 0.1
          },
          model: {
            value: _vm.recipeList[index].ratio,
            callback: function ($$v) {
              _vm.$set(_vm.recipeList[index], "ratio", $$v);
            },
            expression: "recipeList[index].ratio"
          }
        }), _c('span', {
          staticClass: "percentage-append"
        }, [_vm._v("%")])], 1) : _c('span', [_vm._v(_vm._s(row.ratio) + "%")])];
      }
    }, {
      key: "deleteBtn",
      fn: function (_ref2) {
        var row = _ref2.row;
        return [row.name !== '水' ? _c('Icon', {
          staticClass: "deleteBtn",
          attrs: {
            "type": "ios-remove-circle-outline"
          },
          on: {
            "click": function ($event) {
              return _vm.removeMaterialfromRecipe(row._id);
            }
          }
        }) : _vm._e()];
      }
    }])
  })], 1), _c('div', {
    staticClass: "material-panel"
  }, [_c('Input', {
    staticStyle: {
      "margin": "0 4px"
    },
    attrs: {
      "search": "",
      "clearable": "",
      "placeholder": "搜索原材料..."
    },
    on: {
      "on-search": _vm.searchMaterial
    },
    model: {
      value: _vm.searchMaterialText,
      callback: function ($$v) {
        _vm.searchMaterialText = $$v;
      },
      expression: "searchMaterialText"
    }
  }), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("母液")]), _c('div', {
    staticClass: "material-list"
  }, _vm._l(_vm.materialList.filter(function (x) {
    return x.type === 'semi';
  }), function (i, index) {
    return _c('div', {
      key: index,
      class: {
        'm-cell': true,
        selected: _vm.displayData.map(function (e) {
          return e._id;
        }).indexOf(i._id) !== -1
      },
      on: {
        "click": function ($event) {
          return _vm.addToRecipe(i);
        }
      }
    }, [_vm._v(" " + _vm._s(i.name) + " ")]);
  }), 0), _c('Divider', {
    attrs: {
      "orientation": "left"
    }
  }, [_vm._v("原材料")]), _c('div', {
    staticClass: "material-list"
  }, _vm._l(_vm.materialList.filter(function (x) {
    return x.type === 'raw' && x.usedForProduct === true;
  }), function (i, index) {
    return _c('div', {
      key: index,
      class: {
        'm-cell': true,
        selected: _vm.displayData.map(function (e) {
          return e._id;
        }).indexOf(i._id) !== -1
      },
      on: {
        "click": function ($event) {
          return _vm.addToRecipe(i);
        }
      }
    }, [_vm._v(" " + _vm._s(i.name) + " ")]);
  }), 0)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }